import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';

import { AuthService } from './auth.service';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeroesComponent } from './heroes/heroes.component';
import { DataListComponent } from './data-list/data-list.component';
import { AllDataComponent } from './all-data/all-data.component';
import { ClosedStatusComponent } from './closed-status/closed-status.component';
import { HomeComponent } from './home/home.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AdvertiseComponent } from './advertise/advertise.component';
import { ReportingComponent } from './reporting/reporting.component';

//PDF Export 

import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
////


 

 


@NgModule({
  declarations: [
    AppComponent,
    HeroesComponent,
    DataListComponent,
    AllDataComponent,
    ClosedStatusComponent,
    HomeComponent,
    SidebarComponent,
    AdvertiseComponent,
    ReportingComponent
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    FormsModule,
    PDFExportModule
  ],
  providers: [AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
